var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.027,132.229c-3.413-3.413-7.68-5.12-12.8-4.267l-33.28,3.413c-0.353,0.071-0.698,0.165-1.039,0.27l-33.948,3.143 c-5.823,0.582-10.846,4.345-13.453,9.387h-72.495c-2.963-5.086-8.466-8.533-14.746-8.533h-204.8 c-7.423,0-13.761,4.81-16.096,11.461l-28.278,14.139H7.533c-5.12,0-8.533,3.413-8.533,8.533v170.667 c0,5.12,3.413,8.533,8.533,8.533h66.56l28.278,14.139c2.335,6.651,8.673,11.461,16.096,11.461h204.8 c6.28,0,11.782-3.447,14.746-8.533h72.495c2.607,5.041,7.63,8.804,13.453,9.387l34.426,3.279 c0.186,0.048,0.371,0.097,0.561,0.135l33.28,3.413c0.853,0,0.853,0,1.707,0c4.267,0,8.533-1.707,11.093-4.267 c4.267-3.413,5.973-7.68,5.973-12.8v-220.16C511,139.909,509.293,135.642,505.027,132.229z M340.333,229.509H408.6v17.067 h-68.267V229.509z M340.333,263.642H408.6v17.067h-68.267V263.642z M408.6,212.442h-68.267v-17.067H408.6V212.442z M340.333,297.775H408.6v17.067h-68.267V297.775z M408.6,178.309h-68.267v-17.067H408.6V178.309z M75.8,331.909H16.067v-153.6 H75.8c1.707,0,2.56,0,3.413-0.853l22.187-11.093v177.493l-22.187-11.093C78.36,331.909,77.507,331.909,75.8,331.909z M118.467,357.509v-204.8h204.8v204.8H118.467z M340.333,331.909H408.6v17.067h-68.267V331.909z M425.667,357.509v-204.8v-0.853 l25.6-2.56v211.627l-25.6-2.56V357.509z M493.933,365.189l-25.6-2.56v-215.04h3.413c0.704-0.117,1.371-0.304,2.003-0.542 l20.183-2.018V365.189z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,195.375h-68.267c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533H255c5.12,0,8.533-3.413,8.533-8.533 S260.12,195.375,255,195.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,297.775h-68.267c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533H255c5.12,0,8.533-3.413,8.533-8.533 S260.12,297.775,255,297.775z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjo);
export default __webpack_public_path__ + "static/media/objo.889c107829ca724bf3a24771306a320b.svg";
export { ForwardRef as ReactComponent };